import { Icon, IconButton } from '@mui/material';
import { Language as MuiLanguage } from '@mui/icons-material';
import { Language, useTranslation } from '../../../contexts/TranslationContext';
import germany from '../../../assets/germany.png';
import uk from '../../../assets/uk.png';
import us from '../../../assets/us.png';

type LanguageOption = {
  name: string;
  code: Language;
};

export const langaugesItems: LanguageOption[] = [
  { name: 'German', code: 'de' },
  { name: 'English (UK)', code: 'en-GB' },
  { name: 'English (US)', code: 'en-US' },
];

export const languageIconMap: Record<Language, string> = {
  'de': germany,
  'en-GB': uk,
  'en-US': us,
};

type LanguageIconProps = {
  language: Language;
  imgSrc: string;
  languageName: string;
};

export function LanguageIcon({
  imgSrc,
  language,
  languageName,
}: LanguageIconProps) {
  const { t, changeLanguage } = useTranslation();

  return (
    <IconButton
      aria-label={t(languageName)}
      onClick={() => changeLanguage(language)}
      sx={{ p: 0 }}
      disableRipple
      disableFocusRipple
      disableTouchRipple
    >
      <img
        src={imgSrc}
        alt={t('Select Language')}
        style={{ width: 40, height: 40 }}
      />
    </IconButton>
  );
}

export function LanguageToggleIcon() {
  const { language } = useTranslation();

  return languageIconMap[language] ? (
    <Icon sx={{ fontSize: '40px' }}>
      <img
        src={languageIconMap[language]}
        style={{ width: '100%', objectFit: 'contain' }}
        alt={language}
      />
    </Icon>
  ) : (
    <MuiLanguage sx={{ fontSize: '40px' }} />
  );
}
